import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import * as React from 'react';
import { useState } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, deleteDoc, collection, query, where, onSnapshot } from 'firebase/firestore'
import { getStorage, ref, deleteObject, listAll } from "firebase/storage";
import { getAuth, deleteUser, updateEmail } from "firebase/auth";

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function SettingsPage() {
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleDelete = () => {
      if (window.confirm("Do you sure that you want to delete your account? They cannot be recovered once deleted.")) {
        // Delete all recordings in firestore
        const databaseQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email)
        );
        onSnapshot(databaseQuery, snapshot => {
            snapshot.docs.map(file => deleteDoc(doc(firestore, "userDatabase", file.id)))
        })

        const modelQuery = query(
            collection(firestore, 'models'),
            where('user_email', '==', user_email)
        );
        onSnapshot(modelQuery, snapshot => {
          snapshot.docs.map(file => deleteDoc(doc(firestore, "models", file.id)))
        })

        const connectorQuery = query(
            collection(firestore, 'connectors'),
            where('user_email', '==', user_email)
        );
        onSnapshot(connectorQuery, snapshot => {
          snapshot.docs.map(file => deleteDoc(doc(firestore, "connectors", file.id)))
        })

        deleteDoc(doc(firestore, "users", user_email))

        // Delete all files in storage
        listAll(ref(storage, user_email)).then((file) => { 
          file.items.forEach(element => {
            deleteObject(ref(storage, user_email+'/'+element.name))
          });
        })

        // Delete user
        const auth = getAuth();
        const user = auth.currentUser;
        deleteUser(user)
        .then(() => {
          window.localStorage.removeItem('access_token');
          window.location.reload();
        }).catch((error) => {
          console.log(error.message)
        })
      } else {
        alert("Canceled!")
      }
    }

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {/* Sub-Sidebar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                    {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>
                
                <Divider />

                <List component="nav">
                  <ListItemButton href="/Dashboard/Profile" >
                      <ListItemIcon>
                        <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Personal Info" />
                  </ListItemButton>

                  <ListItemButton href="/Dashboard/Profile/Settings" >
                      <ListItemIcon>
                        <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Settings" />
                  </ListItemButton>
                </List>
            </Drawer>

            {/* Main space of page*/}
            <Box>
                {/* Title */}
                <Box sx={{ width: '100%' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Profile / Settings
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Settings
                    </Typography>
                </Box>

                <Box sx={{ ml: 8, mt: 5, display: 'flex' }}>
                  <Typography>Delete this account:</Typography>
                  <Button variant="contained" color="success" sx={{ mt: -0.5, ml: 3 }} onClick={handleDelete}>Delete</Button>
                </Box>

            </Box>

        </Box>
    );
}
